import ReactDOM from 'react-dom';
import React from 'react';
import configureStore from './ifixit_store';
import { Provider } from 'react-redux';
import { withErrorInfo } from './logging.ts';

const getPlaceholders = name => {
   return document.querySelectorAll(`.react-component[data-name="${name}"]`);
};

/**
 * This will mount React component `Component` in placeholder divs that have
 * a data-name of `name`.
 *
 * This is used by the ReactComponent.php class to indicate mount points.
 */
const initializeComponent = (name, Component, defaultProps) => {
   onDomReady(function() {
      var placeholders = getPlaceholders(name);

      Array.convert(placeholders).forEach(placeholder => {
         var props = {
            ...defaultProps,
            ...JSON.parse(placeholder.getAttribute('data-props')),
         };

         withErrorInfo(
            () =>
               ReactDOM.render(
                  <Provider store={store}>
                     <Component {...props} />
                  </Provider>,
                  placeholder
               ),
            console_error =>
               console_error('Error occurred while rendering', Component, 'with props', props)
         );
      });
   });
};

/* Creates a single Redux store for every one of our React components to use.
 * To add to the store, call `store.injectReducer('key', reducer)`.
 */
export const store = configureStore();

export default initializeComponent;
